import React from 'react';
import './KickstartBanner.css';

function KickstartBanner({ onActionClick }) {
  return (
    <div className="kickstart-banner reveal-on-scroll">
      <div className="kickstart-badge-pill">
        <span>READY TO TAKE THE NEXT STEP?</span>
      </div>

      <h2 className="kickstart-title">
        The Right Guidance Can Change a Student’s Entire Future.
      </h2>

      <p className="kickstart-desc">
        Whether you are a student searching for direction or a parent seeking clarity, Deepclariti™ helps you make informed and confident decisions about the road ahead.
      </p>

      <div className="kickstart-buttons">
        <button onClick={onActionClick} className="btn-kickstart-dark">
          Schedule a Consultation
        </button>
      </div>
    </div>
  );
}

export default KickstartBanner;
